(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eaphi-exhibition"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eaphi-exhibition')) {
    customElements.define('eaphi-exhibition', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const dialog = this.querySelector('dialog');
        const links = [...this.querySelectorAll('[data-photo]')];
        const additional = [...this.querySelectorAll('[data-additional]')];
        const more = this.querySelector('[data-more]');
        let active = 0;
        let expanded = this.dataset.editor === 'true';
        if (additional.length && !expanded) {
          additional.forEach(item => { item.hidden = true; });
          this.querySelector('.eaphi-record__more').hidden = false;
        }
        const display = () => {
          const source = links[active];
          if (!source) return;
          const photo = source.querySelector('img').cloneNode(true);
          photo.removeAttribute('srcset');
          photo.removeAttribute('sizes');
          photo.loading = 'eager';
          photo.src = source.href;
          this.querySelector('[data-dialog-photo]').replaceChildren(photo);
          this.querySelector('[data-count]').textContent = `${active + 1} / ${links.length}`;
        };
        this.addEventListener('click', event => {
          const photo = event.target.closest('[data-photo]');
          if (photo && typeof dialog.showModal === 'function') {
            event.preventDefault();
            active = links.indexOf(photo);
            display();
            dialog.showModal();
          }
          if (event.target.closest('[data-close]') || event.target === dialog) dialog.close();
          if (event.target.closest('[data-next]')) { active = (active + 1) % links.length; display(); }
          if (event.target.closest('[data-prev]')) { active = (active + links.length - 1) % links.length; display(); }
          if (event.target.closest('[data-more]')) {
            expanded = !expanded;
            additional.forEach(item => { item.hidden = !expanded; });
            more.setAttribute('aria-expanded', String(expanded));
            more.textContent = expanded ? more.dataset.lessLabel : more.dataset.moreLabel;
            if (!expanded) more.scrollIntoView({block:'center', behavior:'instant'});
          }
        }, options);
        dialog.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          active = (active + (event.key === 'ArrowLeft' ? links.length - 1 : 1)) % links.length;
          display();
        }, options);
      }
      disconnectedCallback() { this.abort?.abort(); this.abort = null; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
